<script setup>
import { ref } from 'vue';

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  activeKey: {
    type: String,
    default: 'role',
  },
});

const emit = defineEmits(['change']);

// 每个导航的颜色
const navColors = {
  role: '#14A2B5',
  knowledge: '#4B52FA',
  scenarios: '#992AFF',
  inboxes: '#FF3B4B',
  handoff: '#2DD4BF',
  tools: '#FE6206',
  settings: '#0DA84A',
};

const hoverKey = ref(null);
const tooltipKey = ref(null);

const handleClick = (key, disabled) => {
  if (disabled) return;
  emit('change', key);
};
</script>

<template>
  <nav
    class="flex flex-col items-center gap-4 py-4 px-1 bg-[#F7F7F7] dark:bg-n-slate-900 rounded-[10px] mt-[10px] mr-0 mb-[10px] ml-[10px]"
  >
    <button
      v-for="item in items"
      :key="item.key"
      class="flex flex-col items-center gap-1 relative"
      :class="{ 'cursor-not-allowed': item.disabled }"
      @click="handleClick(item.key, item.disabled)"
      @mouseenter="
        hoverKey = item.key;
        tooltipKey = item.key;
      "
      @mouseleave="
        hoverKey = null;
        tooltipKey = null;
      "
    >
      <!-- 气泡提示 -->
      <div
        v-if="item.disabled && tooltipKey === item.key"
        class="absolute left-full ml-2 z-50 px-2 py-1 text-xs text-white bg-[#374151] rounded whitespace-nowrap shadow-lg"
      >
        {{ item.disabledTip || '即将发布' }}
        <div
          class="absolute right-full top-1/2 -translate-y-1/2 border-[6px] border-transparent border-r-[#374151]"
        />
      </div>

      <!-- 图标容器：白色背景 + 圆角 + 阴影 -->
      <div
        class="p-[5px] rounded-lg transition-all"
        :class="[
          item.disabled ? 'opacity-40' : '',
          !item.disabled && (activeKey === item.key || hoverKey === item.key)
            ? 'shadow-[0_2px_8px_rgba(0,0,0,0.15)]'
            : '',
        ]"
        :style="{
          backgroundColor:
            !item.disabled && activeKey === item.key
              ? '#fff'
              : !item.disabled && hoverKey === item.key
                ? '#F4F5F6'
                : 'transparent',
        }"
      >
        <span
          :class="item.icon"
          class="text-[22px] block"
          :style="{
            color: item.disabled
              ? '#9CA3AF'
              : activeKey === item.key
                ? navColors[item.key]
                : hoverKey === item.key
                  ? '#0F1015'
                  : '#565A60',
          }"
        />
      </div>
      <!-- 名称 -->
      <span
        class="text-[11px] font-medium"
        :class="[
          item.disabled
            ? 'text-n-slate-9'
            : activeKey === item.key
              ? 'text-n-slate-12 dark:text-white'
              : 'text-n-slate-11',
        ]"
      >
        {{ item.label }}
      </span>
    </button>
  </nav>
</template>
